import { FaRegCircle } from 'react-icons/fa';
import { MdOutlineRectangle } from 'react-icons/md';
import { PiLineVerticalBold } from 'react-icons/pi';
import { CgArrowLongLeft } from 'react-icons/cg';

import { EMagicPenColor, EMagicPenShape } from '@src/types';

export const DEFAULT_STROKE_WIDTH = 3;
export const BASE_OPACITY = 1;
// Eraser constants
export const ERASER_FADE_DURATION_MS = 500; // Duration for erased objects to fade out
export const ERASER_STROKE_WIDTH = 4;
export const ERASER_STROKE_COLOR = '#ff4444';
export const ERASER_DASH_PATTERN = [10, 5];
export const ERASER_STROKE_OPACITY = 0.8;
export const ERASER_HOVER_OPACITY = 0.9;
export const ERASER_INTERPOLATION_STEP_PX = 5; // Pixels between collision detection points
export const ERASER_CLEANUP_INTERVAL_MS = 50; // How often to clean up old strokes and faded objects
// Selection and interaction constants
export const SELECTION_STROKE_COLOR = '#4A90E2';
export const SELECTION_SHADOW_BLUR = 10;
export const SELECTION_SHADOW_BLUR_HOVER = 5;
export const SELECTION_STROKE_WIDTH_INCREASE = 2;
export const HOVER_OPACITY = 0.8;
export const HIT_STROKE_WIDTH = 20; // Invisible hit area for better click detection
// Shape rendering constants
export const STICKER_FONT_SIZE = 40; // Base font size for stickers (responsive size calculated at render time)
export const STICKER_PLACEMENT_OFFSET = 20; // Offset to center sticker on click point
export const DEFAULT_SHAPE_SIZE = 100; // Default width/height for shapes
export const ARROW_POINTER_LENGTH = 10;
export const ARROW_POINTER_WIDTH = 10;
export const LINE_TENSION = 0.5; // Smoothness of curved lines
export const LINE_PREVIEW_DASH = [6, 6];
export const LINE_START_INDICATOR_RADIUS = 4;
export const LINE_START_INDICATOR_STROKE_WIDTH = 2;
// Transformer constants
export const TRANSFORMER_MIN_SIZE = 5; // Minimum width/height for resized shapes
export const MIN_SHAPE_SIZE_TO_RENDER = 0; // Minimum size to render a shape
// Tooltip constants
export const TOOLTIP_OFFSET = { x: 15, y: -10 };
export const TOOLTIP_FONT_SIZE = 12;
export const TOOLTIP_PADDING = 8;
export const TOOLTIP_TAG_POINTER_WIDTH = 8;
export const TOOLTIP_TAG_POINTER_HEIGHT = 6;
export const TOOLTIP_SHADOW_BLUR = 5;
export const TOOLTIP_SHADOW_OFFSET_X = 2;
export const TOOLTIP_SHADOW_OFFSET_Y = 2;
export const TOOLTIP_SHADOW_OPACITY = 0.3;
// Canvas constants
export const STAGE_WIDTH_OFFSET = 100; // Offset from window width for stage
// Colors sub menu options eg: { label: 'Black', value: '#000000' }
export const COLOR_OPTIONS = Object.entries(EMagicPenColor).map(([label, value]) => ({
  label: label.charAt(0) + label.slice(1).toLowerCase(),
  value,
}));

export const DEFAULT_STICKERS = ['🎉', '😂', '♥️', '😔', '💯', '😲'];

export const SHAPE_OPTIONS = [
  {
    label: 'Circle',
    value: EMagicPenShape.CIRCLE,
    icon: <FaRegCircle style={{ fontSize: 18 }} />,
  },
  {
    label: 'Rectangle',
    value: EMagicPenShape.RECTANGLE,
    icon: <MdOutlineRectangle style={{ fontSize: 18 }} />,
  },
  {
    label: 'Line',
    value: EMagicPenShape.LINE,
    icon: <PiLineVerticalBold style={{ transform: 'rotate(45deg)', fontSize: 18 }} />,
  },
  {
    label: 'Arrow',
    value: EMagicPenShape.ARROW,
    icon: <CgArrowLongLeft style={{ transform: 'scaleX(-1)', fontSize: 18 }} />,
  },
] as const;

export const EPHEMERAL_PEN_TTL = 6000;
export const FADE_START_TIME = 5000;
export const FADE_DURATION = 1000;
